import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CustomPage',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CustomPage',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CustomPage',
    column_type: 'datetime',
  },
  title: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
  slug: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
  default: {
    model_name: 'CustomPage',
    column_type: 'boolean',
  },
  mini_program_path: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
  published_at: {
    model_name: 'CustomPage',
    column_type: 'datetime',
  },
  formal_custom_page_id: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
  formal_custom_page: {
    model_name: 'CustomPage',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'formal_custom_page',
      model_name: 'CustomPage',
      foreign_key: 'draft_custom_page_id',
    },
  },
  draft_custom_page_id: {
    model_name: 'CustomPage',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'formal_custom_page',
      model_name: 'CustomPage',
      foreign_key: 'draft_custom_page_id',
    },
  },
  can_rollback_data: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
  configs: {
    model_name: 'CustomPage',
    column_type: 'string',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
